import React from 'react';
import Button, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import classNames from 'classnames';

export interface IButtonActionProps extends AntButtonProps {
  children?: React.ReactNode;
  showButton?: boolean;
  onClick?: () => any;
  icon?: React.ReactNode;
  text?: string;
  type?: 'link' | 'text' | 'ghost' | 'default' | 'primary' | 'dashed';
}

export default function ButtonActionStatus({ ...props }: IButtonActionProps) {
  // console.log(props.showButton, props.text, props.type);
  return (
    <div className={''}>
      {props.showButton && (
        <Button
          type={props.type!}
          onClick={() => props.onClick && props.onClick()}
          icon={props.icon && props.icon}
          {...props}
        >
          {props.text}
        </Button>
      )}
    </div>
  );
}
